const chemistryQuestions = [

{
  question: "Chemistry is the study of:",
  options: ["matter and its changes", "living organisms", "motion", "energy only"],
  answer: "matter and its changes"
},
{
  question: "Which is NOT a branch of pure chemistry?",
  options: ["Organic", "Physical", "Biochemistry", "Inorganic"],
  answer: "Biochemistry"
},
{
  question: "Which is an applied chemistry field?",
  options: ["Petrochemistry", "Physical chemistry", "Inorganic", "Organic"],
  answer: "Petrochemistry"
},
{
  question: "SI unit of mass is:",
  options: ["kg", "g", "mg", "tonne"],
  answer: "kg"
},
{
  question: "SI unit of volume is:",
  options: ["m³", "cm³", "L", "dm³"],
  answer: "m³"
},
{
  question: "Instrument used to measure mass:",
  options: ["balance", "thermometer", "burette", "pipette"],
  answer: "balance"
},
{
  question: "Instrument used to measure temperature:",
  options: ["thermometer", "balance", "stopwatch", "meter rule"],
  answer: "thermometer"
},
{
  question: "Precision refers to:",
  options: ["repeatability", "correctness", "accuracy", "error"],
  answer: "repeatability"
},
{
  question: "Accuracy refers to:",
  options: ["closeness to true value", "repeatability", "random error", "none"],
  answer: "closeness to true value"
},
{
  question: "Which is a derived unit?",
  options: ["m/s", "kg", "m", "s"],
  answer: "m/s"
},
{
  question: "Scientific method begins with:",
  options: ["problem identification", "experiment", "conclusion", "law"],
  answer: "problem identification"
},
{
  question: "Hypothesis is:",
  options: ["testable prediction", "law", "theory", "fact"],
  answer: "testable prediction"
},
{
  question: "Which is NOT lab equipment?",
  options: ["burette", "pipette", "thermometer", "radio"],
  answer: "radio"
},
{
  question: "Hazard symbol shows:",
  options: ["danger", "formula", "mass", "reaction"],
  answer: "danger"
},
{
  question: "Corrosive substances:",
  options: ["burn skin", "freeze", "explode", "evaporate"],
  answer: "burn skin"
},
{
  question: "PPE stands for:",
  options: ["Personal Protective Equipment", "Public Equipment", "Private Protection", "None"],
  answer: "Personal Protective Equipment"
},
{
  question: "Example of PPE:",
  options: ["gloves", "paper", "book", "pen"],
  answer: "gloves"
},
{
  question: "Fire extinguisher is used to:",
  options: ["put out fire", "measure", "heat", "cool"],
  answer: "put out fire"
},
{
  question: "Chemicals should not be stored alphabetically because:",
  options: ["dangerous reactions", "cost", "color", "size"],
  answer: "dangerous reactions"
},
{
  question: "Unit of time:",
  options: ["second", "minute", "hour", "day"],
  answer: "second"
},
{
  question: "Volume is measured using:",
  options: ["burette", "balance", "thermometer", "ruler"],
  answer: "burette"
},
{
  question: "Measurement error is:",
  options: ["difference from true value", "value", "unit", "instrument"],
  answer: "difference from true value"
},
{
  question: "Significant figures show:",
  options: ["precision", "units", "error", "value"],
  answer: "precision"
},
{
  question: "Which is basic unit?",
  options: ["meter", "m/s", "N", "Pa"],
  answer: "meter"
},
{
  question: "Which is derived unit?",
  options: ["Newton", "meter", "kg", "second"],
  answer: "Newton"
},
{
  question: "Scientific measurement is important because:",
  options: ["accuracy in results", "beauty", "size", "color"],
  answer: "accuracy in results"
},
{
  question: "Laboratory coat protects:",
  options: ["body", "equipment", "chemicals", "air"],
  answer: "body"
},
{
  question: "First aid is:",
  options: ["immediate treatment", "final treatment", "experiment", "test"],
  answer: "immediate treatment"
},
{
  question: "Fire blanket is used to:",
  options: ["cover fire", "measure", "heat", "cool"],
  answer: "cover fire"
},
{
  question: "Science depends heavily on:",
  options: ["measurement", "guess", "color", "size"],
  answer: "measurement"
},

{
  question: "Matter is made up of:",
  options: ["atoms", "cells", "energy", "light"],
  answer: "atoms"
},
{
  question: "Smallest particle of an element:",
  options: ["atom", "molecule", "ion", "compound"],
  answer: "atom"
},
{
  question: "Dalton proposed that atoms are:",
  options: ["indivisible", "divisible", "charged", "unstable"],
  answer: "indivisible"
},
{
  question: "Electron was discovered by:",
  options: ["J.J. Thomson", "Rutherford", "Bohr", "Dalton"],
  answer: "J.J. Thomson"
},
{
  question: "Nucleus was discovered by:",
  options: ["Rutherford", "Thomson", "Bohr", "Dalton"],
  answer: "Rutherford"
},
{
  question: "Bohr model explains:",
  options: ["energy levels", "nucleus", "electron", "mass"],
  answer: "energy levels"
},
{
  question: "Charge of electron:",
  options: ["−1", "+1", "0", "+2"],
  answer: "−1"
},
{
  question: "Charge of proton:",
  options: ["+1", "−1", "0", "+2"],
  answer: "+1"
},
{
  question: "Neutron charge:",
  options: ["0", "+1", "−1", "+2"],
  answer: "0"
},
{
  question: "Atomic number equals:",
  options: ["protons", "neutrons", "mass", "electrons only"],
  answer: "protons"
},
{
  question: "Mass number equals:",
  options: ["protons + neutrons", "protons", "electrons", "neutrons"],
  answer: "protons + neutrons"
},
{
  question: "Isotopes have same:",
  options: ["protons", "neutrons", "mass", "charge"],
  answer: "protons"
},
{
  question: "Isotopes differ in:",
  options: ["neutrons", "protons", "electrons", "charge"],
  answer: "neutrons"
},
{
  question: "Example of isotope:",
  options: ["C-12 and C-14", "Na and Cl", "H2O", "CO2"],
  answer: "C-12 and C-14"
},
{
  question: "Relative atomic mass of Cl (35, 37 equally):",
  options: ["36", "35", "37", "34"],
  answer: "36"
},
{
  question: "If 75% isotope = 10, 25% = 11, Ar:",
  options: ["10.25", "10.5", "11", "10"],
  answer: "10.25"
},
{
  question: "Electron configuration of Na (11):",
  options: ["2,8,1", "2,8,2", "2,7,2", "2,8"],
  answer: "2,8,1"
},
{
  question: "Electron configuration of Mg (12):",
  options: ["2,8,2", "2,8,1", "2,7,3", "2,6,4"],
  answer: "2,8,2"
},
{
  question: "Valence electrons of Na:",
  options: ["1", "2", "8", "11"],
  answer: "1"
},
{
  question: "Element with 2,8,8 is:",
  options: ["noble gas", "metal", "non-metal", "halogen"],
  answer: "noble gas"
},
{
  question: "Group number equals:",
  options: ["valence electrons", "protons", "neutrons", "mass"],
  answer: "valence electrons"
},
{
  question: "Period number equals:",
  options: ["shells", "protons", "neutrons", "valence"],
  answer: "shells"
},
{
  question: "Atomic radius increases:",
  options: ["down group", "across period", "constant", "random"],
  answer: "down group"
},
{
  question: "Atomic radius decreases:",
  options: ["across period", "down group", "constant", "random"],
  answer: "across period"
},
{
  question: "Ionization energy increases:",
  options: ["across period", "down group", "constant", "random"],
  answer: "across period"
},
{
  question: "Ionization energy decreases:",
  options: ["down group", "across period", "constant", "random"],
  answer: "down group"
},
{
  question: "Electronegativity increases:",
  options: ["across period", "down group", "constant", "random"],
  answer: "across period"
},
{
  question: "Metals are found:",
  options: ["left", "right", "middle only", "top"],
  answer: "left"
},
{
  question: "Non-metals are found:",
  options: ["right", "left", "middle", "bottom"],
  answer: "right"
},
{
  question: "Halogens are:",
  options: ["Group 7", "Group 1", "Group 2", "Group 8"],
  answer: "Group 7"
},
{
  question: "Noble gases are:",
  options: ["Group 8", "Group 1", "Group 2", "Group 7"],
  answer: "Group 8"
},
{
  question: "Transition metals are:",
  options: ["middle", "left", "right", "top"],
  answer: "middle"
},
{
  question: "Na reacts with water to form:",
  options: ["NaOH", "NaCl", "Na2O", "Na2CO3"],
  answer: "NaOH"
},
{
  question: "Mg is:",
  options: ["metal", "non-metal", "gas", "liquid"],
  answer: "metal"
},
{
  question: "Cl is:",
  options: ["non-metal", "metal", "gas only", "liquid"],
  answer: "non-metal"
},
{
  question: "Mass spectrometer measures:",
  options: ["mass", "volume", "temperature", "time"],
  answer: "mass"
},
{
  question: "Electron enters orbital following:",
  options: ["Aufbau principle", "Pauli only", "Hund only", "random"],
  answer: "Aufbau principle"
},
{
  question: "No two electrons have same quantum numbers:",
  options: ["Pauli exclusion", "Hund rule", "Bohr rule", "Dalton"],
  answer: "Pauli exclusion"
},
{
  question: "Electrons occupy orbitals singly first:",
  options: ["Hund rule", "Pauli", "Aufbau", "Bohr"],
  answer: "Hund rule"
},
{
  question: "Shape of s orbital:",
  options: ["spherical", "linear", "planar", "triangular"],
  answer: "spherical"
},
{
  question: "Shape of p orbital:",
  options: ["dumbbell", "sphere", "cube", "triangle"],
  answer: "dumbbell"
},

{
  question: "Chemical bond is:",
  options: ["force holding atoms", "reaction", "energy", "mass"],
  answer: "force holding atoms"
},
{
  question: "Ionic bond involves:",
  options: ["electron transfer", "sharing", "no electrons", "protons"],
  answer: "electron transfer"
},
{
  question: "Covalent bond involves:",
  options: ["electron sharing", "transfer", "protons", "neutrons"],
  answer: "electron sharing"
},
{
  question: "Ionic bond occurs between:",
  options: ["metal + non-metal", "metal + metal", "non-metal + non-metal", "gas + gas"],
  answer: "metal + non-metal"
},
{
  question: "Covalent bond occurs between:",
  options: ["non-metal + non-metal", "metal + metal", "metal + non-metal", "ion + ion"],
  answer: "non-metal + non-metal"
},
{
  question: "Example of ionic compound:",
  options: ["NaCl", "H2O", "CO2", "CH4"],
  answer: "NaCl"
},
{
  question: "Example of covalent compound:",
  options: ["H2O", "NaCl", "KBr", "MgO"],
  answer: "H2O"
},
{
  question: "Na loses electron to become:",
  options: ["Na+", "Na−", "Na2+", "Na2−"],
  answer: "Na+"
},
{
  question: "Cl gains electron to become:",
  options: ["Cl−", "Cl+", "Cl2+", "Cl2−"],
  answer: "Cl−"
},
{
  question: "Electrovalency refers to:",
  options: ["electron transfer", "sharing", "protons", "mass"],
  answer: "electron transfer"
},
{
  question: "Covalency refers to:",
  options: ["sharing electrons", "transfer", "mass", "charge"],
  answer: "sharing electrons"
},
{
  question: "Octet rule means:",
  options: ["8 electrons in outer shell", "2 electrons", "10 electrons", "6 electrons"],
  answer: "8 electrons in outer shell"
},
{
  question: "Which obeys octet rule?",
  options: ["Ne", "H", "He", "Li"],
  answer: "Ne"
},
{
  question: "Hydrogen needs:",
  options: ["2 electrons", "8 electrons", "4 electrons", "6 electrons"],
  answer: "2 electrons"
},
{
  question: "Lewis structure shows:",
  options: ["valence electrons", "mass", "protons", "neutrons"],
  answer: "valence electrons"
},
{
  question: "Number of bonds in O2:",
  options: ["2", "1", "3", "4"],
  answer: "2"
},
{
  question: "Number of bonds in N2:",
  options: ["3", "2", "1", "4"],
  answer: "3"
},
{
  question: "Single bond means:",
  options: ["1 pair electrons", "2 pairs", "3 pairs", "4 pairs"],
  answer: "1 pair electrons"
},
{
  question: "Double bond means:",
  options: ["2 pairs electrons", "1 pair", "3 pairs", "4 pairs"],
  answer: "2 pairs electrons"
},
{
  question: "Triple bond means:",
  options: ["3 pairs electrons", "1 pair", "2 pairs", "4 pairs"],
  answer: "3 pairs electrons"
},
{
  question: "Bond energy increases with:",
  options: ["bond strength", "length", "mass", "size"],
  answer: "bond strength"
},
{
  question: "Ionic compounds have:",
  options: ["high melting point", "low melting", "no melting", "gas"],
  answer: "high melting point"
},
{
  question: "Covalent compounds have:",
  options: ["low melting point", "high melting", "metallic", "strong ionic"],
  answer: "low melting point"
},
{
  question: "Ionic compounds conduct electricity when:",
  options: ["molten or dissolved", "solid", "gas", "dry"],
  answer: "molten or dissolved"
},
{
  question: "Covalent compounds generally:",
  options: ["do not conduct", "conduct well", "are metals", "are ionic"],
  answer: "do not conduct"
},
{
  question: "Metallic bonding involves:",
  options: ["sea of electrons", "transfer", "sharing", "ions only"],
  answer: "sea of electrons"
},
{
  question: "Metallic bond explains:",
  options: ["conductivity", "color", "mass", "gas"],
  answer: "conductivity"
},
{
  question: "Allotropy means:",
  options: ["different forms same element", "compounds", "mixtures", "solutions"],
  answer: "different forms same element"
},
{
  question: "Example of allotropy:",
  options: ["diamond & graphite", "NaCl", "H2O", "CO2"],
  answer: "diamond & graphite"
},
{
  question: "Graphite conducts because:",
  options: ["free electrons", "ions", "heat", "mass"],
  answer: "free electrons"
},
{
  question: "Diamond is hard because:",
  options: ["strong covalent network", "ionic bond", "weak bonds", "gas"],
  answer: "strong covalent network"
},
{
  question: "Polar bond occurs when:",
  options: ["unequal sharing", "equal sharing", "transfer", "no sharing"],
  answer: "unequal sharing"
},
{
  question: "Non-polar bond occurs when:",
  options: ["equal sharing", "unequal sharing", "transfer", "none"],
  answer: "equal sharing"
},
{
  question: "Water is:",
  options: ["polar", "non-polar", "ionic", "metallic"],
  answer: "polar"
},
{
  question: "CO2 is:",
  options: ["non-polar", "polar", "ionic", "metal"],
  answer: "non-polar"
},
{
  question: "Intermolecular forces include:",
  options: ["van der Waals", "ionic", "covalent", "metallic"],
  answer: "van der Waals"
},
{
  question: "Hydrogen bonding occurs in:",
  options: ["H2O", "NaCl", "CO2", "CH4"],
  answer: "H2O"
},
{
  question: "Stronger intermolecular forces give:",
  options: ["higher boiling point", "lower boiling", "gas", "weak"],
  answer: "higher boiling point"
},
{
  question: "Weak forces lead to:",
  options: ["low boiling point", "high boiling", "strong bonds", "solid"],
  answer: "low boiling point"
},

{
  question: "How many moles are in 22g of CO2? (C=12,O=16)",
  options: ["0.5", "1", "2", "0.25"],
  answer: "0.5"
},
{
  question: "Mass of 0.25 moles of NaCl (Na=23,Cl=35.5)",
  options: ["14.625g", "29.25g", "58.5g", "7.3g"],
  answer: "14.625g"
},
{
  question: "Number of moles in 44.8dm³ of gas at STP",
  options: ["2", "1", "0.5", "4"],
  answer: "2"
},
{
  question: "Volume of 1 mole of gas at STP",
  options: ["22.4dm³", "24dm³", "11.2dm³", "44.8dm³"],
  answer: "22.4dm³"
},
{
  question: "How many molecules in 1 mole?",
  options: ["6.02×10²³", "6.02×10²²", "1×10²³", "6×10²⁴"],
  answer: "6.02×10²³"
},
{
  question: "Mass of 2 moles of H2O (H=1,O=16)",
  options: ["36g", "18g", "20g", "32g"],
  answer: "36g"
},
{
  question: "Empirical formula of C2H6",
  options: ["CH3", "C2H6", "CH2", "C3H6"],
  answer: "CH3"
},
{
  question: "Molecular formula if empirical = CH2, molar mass = 28",
  options: ["C2H4", "CH2", "C3H6", "C4H8"],
  answer: "C2H4"
},
{
  question: "Find % of oxygen in H2O",
  options: ["88.9%", "50%", "11.1%", "66.7%"],
  answer: "88.9%"
},
{
  question: "Find % of carbon in CO2",
  options: ["27.3%", "50%", "33.3%", "66.7%"],
  answer: "27.3%"
},
{
  question: "Calculate molarity: 1 mole in 2dm³",
  options: ["0.5M", "2M", "1M", "0.25M"],
  answer: "0.5M"
},
{
  question: "Mass of solute in 0.5M, 1dm³ NaOH (Na=23,O=16,H=1)",
  options: ["20g", "40g", "10g", "5g"],
  answer: "20g"
},
{
  question: "Find molarity: 10g NaCl in 1dm³ (58.5)",
  options: ["0.17M", "1M", "0.5M", "2M"],
  answer: "0.17M"
},
{
  question: "Number of moles in 5g of H2 (H=1)",
  options: ["2.5", "5", "1", "10"],
  answer: "2.5"
},
{
  question: "Gas law: double temperature, volume becomes?",
  options: ["double", "half", "same", "zero"],
  answer: "double"
},
{
  question: "Boyle’s law: pressure inversely to:",
  options: ["volume", "temperature", "mass", "moles"],
  answer: "volume"
},
{
  question: "Find volume if P doubles (Boyle)",
  options: ["half", "double", "same", "zero"],
  answer: "half"
},
{
  question: "Equation: 2H2 + O2 → 2H2O, moles ratio H2:O2",
  options: ["2:1", "1:2", "1:1", "2:2"],
  answer: "2:1"
},
{
  question: "If 4 moles H2 reacts, O2 needed?",
  options: ["2 moles", "4 moles", "1 mole", "8 moles"],
  answer: "2 moles"
},
{
  question: "Limiting reagent is:",
  options: ["reactant used up first", "largest", "smallest", "product"],
  answer: "reactant used up first"
},
{
  question: "Excess reagent is:",
  options: ["leftover", "used first", "none", "product"],
  answer: "leftover"
},
{
  question: "Find molar mass of CaCO3 (Ca=40,C=12,O=16)",
  options: ["100", "56", "44", "84"],
  answer: "100"
},
{
  question: "Find moles in 50g CaCO3",
  options: ["0.5", "1", "2", "0.25"],
  answer: "0.5"
},
{
  question: "Find volume of 0.5 mol gas at STP",
  options: ["11.2dm³", "22.4dm³", "5.6dm³", "44.8dm³"],
  answer: "11.2dm³"
},
{
  question: "Calculate % yield: actual 8g, theoretical 10g",
  options: ["80%", "125%", "20%", "50%"],
  answer: "80%"
},
{
  question: "Molar gas constant R is:",
  options: ["8.314", "22.4", "6.02", "1"],
  answer: "8.314"
},
{
  question: "If n doubles, volume:",
  options: ["double", "half", "same", "zero"],
  answer: "double"
},
{
  question: "Find density: mass 44g, volume 22.4dm³",
  options: ["1.96 g/dm³", "2 g/dm³", "0.5", "4"],
  answer: "1.96 g/dm³"
},
{
  question: "1 mole of any gas at STP contains:",
  options: ["same molecules", "different", "less", "more"],
  answer: "same molecules"
},
{
  question: "Avogadro law relates volume to:",
  options: ["moles", "mass", "pressure", "temperature"],
  answer: "moles"
},

{
  question: "Which state has definite volume but no definite shape?",
  options: ["liquid", "solid", "gas", "plasma"],
  answer: "liquid"
},
{
  question: "Which state is highly compressible?",
  options: ["gas", "liquid", "solid", "plasma"],
  answer: "gas"
},
{
  question: "Particles in gas are:",
  options: ["far apart", "close", "fixed", "rigid"],
  answer: "far apart"
},
{
  question: "Diffusion is fastest in:",
  options: ["gas", "liquid", "solid", "all same"],
  answer: "gas"
},
{
  question: "Kinetic theory assumes particles are:",
  options: ["in constant motion", "static", "heavy", "charged"],
  answer: "in constant motion"
},
{
  question: "Increase in temperature increases:",
  options: ["kinetic energy", "mass", "volume only", "pressure only"],
  answer: "kinetic energy"
},
{
  question: "Boyle’s law is constant:",
  options: ["temperature", "pressure", "volume", "mass"],
  answer: "temperature"
},
{
  question: "Charles’ law is constant:",
  options: ["pressure", "temperature", "volume", "mass"],
  answer: "pressure"
},
{
  question: "Convert 27°C to Kelvin",
  options: ["300K", "273K", "27K", "250K"],
  answer: "300K"
},
{
  question: "Convert 0°C to Kelvin",
  options: ["273K", "0K", "100K", "200K"],
  answer: "273K"
},
{
  question: "If V doubles at constant T, pressure:",
  options: ["halves", "doubles", "same", "zero"],
  answer: "halves"
},
{
  question: "If temperature doubles (Kelvin), volume:",
  options: ["doubles", "halves", "same", "zero"],
  answer: "doubles"
},
{
  question: "P1=2atm, V1=4L, V2=2L, find P2",
  options: ["4atm", "2atm", "1atm", "8atm"],
  answer: "4atm"
},
{
  question: "V1=3L, T1=300K, T2=600K, find V2",
  options: ["6L", "3L", "2L", "1L"],
  answer: "6L"
},
{
  question: "Ideal gas assumes:",
  options: ["no forces", "strong forces", "heavy particles", "static"],
  answer: "no forces"
},
{
  question: "Real gases deviate due to:",
  options: ["forces", "mass", "volume only", "temperature only"],
  answer: "forces"
},
{
  question: "STP conditions:",
  options: ["0°C,1atm", "25°C,1atm", "0°C,2atm", "100°C"],
  answer: "0°C,1atm"
},
{
  question: "Density of gas increases with:",
  options: ["pressure", "volume", "temperature", "motion"],
  answer: "pressure"
},
{
  question: "Which gas diffuses fastest?",
  options: ["H2", "O2", "CO2", "N2"],
  answer: "H2"
},
{
  question: "Graham’s law depends on:",
  options: ["molar mass", "volume", "pressure", "temperature"],
  answer: "molar mass"
},
{
  question: "Lower molar mass → diffusion:",
  options: ["faster", "slower", "same", "none"],
  answer: "faster"
},
{
  question: "Pressure is due to:",
  options: ["collisions", "mass", "gravity", "charge"],
  answer: "collisions"
},
{
  question: "Increase pressure → particles:",
  options: ["closer", "farther", "same", "none"],
  answer: "closer"
},
{
  question: "Phase change solid→liquid:",
  options: ["melting", "freezing", "boiling", "condensing"],
  answer: "melting"
},
{
  question: "Liquid→gas:",
  options: ["boiling", "freezing", "melting", "condensing"],
  answer: "boiling"
},
{
  question: "Gas→liquid:",
  options: ["condensation", "melting", "freezing", "sublimation"],
  answer: "condensation"
},
{
  question: "Solid→gas:",
  options: ["sublimation", "melting", "freezing", "boiling"],
  answer: "sublimation"
},
{
  question: "Latent heat is:",
  options: ["heat without temp change", "heat with change", "energy lost", "energy gained"],
  answer: "heat without temp change"
},
{
  question: "Boiling occurs when:",
  options: ["vapour pressure = external pressure", "temp high", "mass low", "none"],
  answer: "vapour pressure = external pressure"
},
{
  question: "If pressure increases, boiling point:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "If pressure decreases, boiling point:",
  options: ["decreases", "increases", "same", "zero"],
  answer: "decreases"
},
{
  question: "Combined gas law is:",
  options: ["PV/T constant", "PV constant", "V/T constant", "P/T constant"],
  answer: "PV/T constant"
},
{
  question: "If P doubles, T constant, V:",
  options: ["halves", "doubles", "same", "zero"],
  answer: "halves"
},
{
  question: "Ideal gas obeys laws at:",
  options: ["low pressure", "high pressure", "low temp", "liquid state"],
  answer: "low pressure"
},
{
  question: "Real gas becomes ideal at:",
  options: ["high temp", "low temp", "high pressure", "liquid"],
  answer: "high temp"
},
{
  question: "Diffusion depends on:",
  options: ["mass", "volume", "color", "shape"],
  answer: "mass"
},
{
  question: "Rate of diffusion ∝",
  options: ["1/√mass", "mass", "volume", "pressure"],
  answer: "1/√mass"
},
{
  question: "Which has strongest forces?",
  options: ["solid", "liquid", "gas", "plasma"],
  answer: "solid"
},
{
  question: "Which has weakest forces?",
  options: ["gas", "liquid", "solid", "plasma"],
  answer: "gas"
},

{
  question: "Energy change in a reaction is called:",
  options: ["enthalpy change", "mass change", "volume change", "pressure"],
  answer: "enthalpy change"
},
{
  question: "Exothermic reaction releases:",
  options: ["heat", "mass", "volume", "gas"],
  answer: "heat"
},
{
  question: "Endothermic reaction absorbs:",
  options: ["heat", "mass", "volume", "gas"],
  answer: "heat"
},
{
  question: "Sign of ΔH for exothermic:",
  options: ["negative", "positive", "zero", "undefined"],
  answer: "negative"
},
{
  question: "Sign of ΔH for endothermic:",
  options: ["positive", "negative", "zero", "undefined"],
  answer: "positive"
},
{
  question: "q = mcΔT, c is:",
  options: ["specific heat capacity", "mass", "temperature", "volume"],
  answer: "specific heat capacity"
},
{
  question: "If m=2g, c=4.2, ΔT=5°C, q=",
  options: ["42J", "21J", "10J", "84J"],
  answer: "42J"
},
{
  question: "If q=84J, m=2g, c=4.2, ΔT=",
  options: ["10°C", "5°C", "2°C", "20°C"],
  answer: "10°C"
},
{
  question: "Unit of enthalpy:",
  options: ["kJ/mol", "g/mol", "mol", "Pa"],
  answer: "kJ/mol"
},
{
  question: "Bond breaking is:",
  options: ["endothermic", "exothermic", "neutral", "zero"],
  answer: "endothermic"
},
{
  question: "Bond formation is:",
  options: ["exothermic", "endothermic", "neutral", "zero"],
  answer: "exothermic"
},
{
  question: "Standard conditions:",
  options: ["25°C, 1atm", "0°C, 1atm", "100°C", "1K"],
  answer: "25°C, 1atm"
},
{
  question: "ΔH negative means:",
  options: ["heat released", "heat absorbed", "no change", "zero"],
  answer: "heat released"
},
{
  question: "ΔH positive means:",
  options: ["heat absorbed", "heat released", "zero", "none"],
  answer: "heat absorbed"
},
{
  question: "Hess’s law states:",
  options: ["total ΔH independent of path", "depends on path", "random", "none"],
  answer: "total ΔH independent of path"
},
{
  question: "If ΔH1 = −100, ΔH2 = −50, total:",
  options: ["−150", "150", "−50", "50"],
  answer: "−150"
},
{
  question: "If ΔH1 = −200, ΔH2 = +50, total:",
  options: ["−150", "150", "−250", "250"],
  answer: "−150"
},
{
  question: "Enthalpy of combustion is:",
  options: ["burning reaction heat", "cooling", "freezing", "melting"],
  answer: "burning reaction heat"
},
{
  question: "Enthalpy of formation is:",
  options: ["formation from elements", "burning", "cooling", "none"],
  answer: "formation from elements"
},
{
  question: "Calorimeter measures:",
  options: ["heat change", "mass", "volume", "pressure"],
  answer: "heat change"
},
{
  question: "If temperature increases, reaction is:",
  options: ["exothermic", "endothermic", "neutral", "none"],
  answer: "exothermic"
},
{
  question: "If temperature decreases:",
  options: ["endothermic", "exothermic", "neutral", "none"],
  answer: "endothermic"
},
{
  question: "Energy profile shows:",
  options: ["energy change", "mass", "volume", "pressure"],
  answer: "energy change"
},
{
  question: "Activation energy is:",
  options: ["minimum energy needed", "maximum energy", "heat lost", "mass"],
  answer: "minimum energy needed"
},
{
  question: "Catalyst reduces:",
  options: ["activation energy", "mass", "volume", "heat"],
  answer: "activation energy"
},
{
  question: "If Ea decreases, reaction:",
  options: ["faster", "slower", "same", "zero"],
  answer: "faster"
},
{
  question: "Combustion is always:",
  options: ["exothermic", "endothermic", "neutral", "none"],
  answer: "exothermic"
},
{
  question: "Endothermic graph shows products:",
  options: ["higher energy", "lower energy", "same", "zero"],
  answer: "higher energy"
},
{
  question: "Exothermic graph shows products:",
  options: ["lower energy", "higher energy", "same", "zero"],
  answer: "lower energy"
},
{
  question: "Energy change depends on:",
  options: ["bonds broken & formed", "mass", "volume", "pressure"],
  answer: "bonds broken & formed"
},
{
  question: "Heat capacity depends on:",
  options: ["substance", "color", "shape", "size"],
  answer: "substance"
},
{
  question: "If ΔT = 0, q =",
  options: ["0", "1", "2", "10"],
  answer: "0"
},
{
  question: "More mass → heat absorbed:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "Higher ΔT → q:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "Heat energy unit:",
  options: ["Joule", "Newton", "Pascal", "mole"],
  answer: "Joule"
},
{
  question: "1 kJ =",
  options: ["1000 J", "100 J", "10 J", "1 J"],
  answer: "1000 J"
},
{
  question: "Fuel value depends on:",
  options: ["energy released", "mass", "color", "shape"],
  answer: "energy released"
},
{
  question: "Endothermic requires:",
  options: ["energy input", "energy output", "none", "zero"],
  answer: "energy input"
},
{
  question: "Exothermic gives:",
  options: ["energy output", "input", "none", "zero"],
  answer: "energy output"
},

{
  question: "Rate of reaction is:",
  options: ["change per time", "mass change", "volume only", "temperature"],
  answer: "change per time"
},
{
  question: "Unit of rate:",
  options: ["mol/s", "g", "Pa", "J"],
  answer: "mol/s"
},
{
  question: "Collision theory states reactions occur when:",
  options: ["particles collide", "heat added", "pressure added", "volume changes"],
  answer: "particles collide"
},
{
  question: "Effective collision requires:",
  options: ["correct energy & orientation", "mass only", "temperature only", "volume"],
  answer: "correct energy & orientation"
},
{
  question: "Activation energy is:",
  options: ["minimum energy needed", "maximum energy", "mass", "volume"],
  answer: "minimum energy needed"
},
{
  question: "Increase temperature causes rate to:",
  options: ["increase", "decrease", "same", "zero"],
  answer: "increase"
},
{
  question: "Higher temperature means:",
  options: ["more collisions", "less collisions", "no collisions", "constant"],
  answer: "more collisions"
},
{
  question: "Increase concentration causes:",
  options: ["faster rate", "slower", "same", "zero"],
  answer: "faster rate"
},
{
  question: "Increase pressure affects:",
  options: ["gases", "solids", "liquids", "all"],
  answer: "gases"
},
{
  question: "Catalyst effect:",
  options: ["lowers Ea", "raises Ea", "no effect", "changes products"],
  answer: "lowers Ea"
},
{
  question: "Catalyst increases rate by:",
  options: ["lowering Ea", "raising temp", "increasing mass", "volume"],
  answer: "lowering Ea"
},
{
  question: "Surface area increase:",
  options: ["faster reaction", "slower", "same", "zero"],
  answer: "faster reaction"
},
{
  question: "Powder reacts faster because:",
  options: ["larger surface area", "smaller mass", "color", "shape"],
  answer: "larger surface area"
},
{
  question: "Graph of rate vs time shows:",
  options: ["decrease over time", "increase always", "constant", "random"],
  answer: "decrease over time"
},
{
  question: "Initial rate is:",
  options: ["rate at start", "rate at end", "average rate", "zero"],
  answer: "rate at start"
},
{
  question: "Rate is highest at:",
  options: ["beginning", "end", "middle", "constant"],
  answer: "beginning"
},
{
  question: "Rate slows because:",
  options: ["reactants decrease", "temperature drops", "pressure drops", "volume"],
  answer: "reactants decrease"
},
{
  question: "Half-life is:",
  options: ["time for half reactant used", "full reaction time", "double time", "zero"],
  answer: "time for half reactant used"
},
{
  question: "Short half-life means:",
  options: ["fast reaction", "slow reaction", "constant", "none"],
  answer: "fast reaction"
},
{
  question: "Long half-life means:",
  options: ["slow reaction", "fast reaction", "constant", "none"],
  answer: "slow reaction"
},
{
  question: "Rate ∝ concentration means:",
  options: ["direct relationship", "inverse", "none", "zero"],
  answer: "direct relationship"
},
{
  question: "Doubling concentration makes rate:",
  options: ["increase", "decrease", "same", "zero"],
  answer: "increase"
},
{
  question: "Activation energy diagram shows:",
  options: ["energy barrier", "mass", "volume", "pressure"],
  answer: "energy barrier"
},
{
  question: "Catalyst changes:",
  options: ["pathway", "products", "reactants", "energy output"],
  answer: "pathway"
},
{
  question: "Endothermic Ea is:",
  options: ["higher", "lower", "same", "zero"],
  answer: "higher"
},
{
  question: "Exothermic Ea is:",
  options: ["lower", "higher", "same", "zero"],
  answer: "lower"
},
{
  question: "Reaction rate measured by:",
  options: ["gas volume", "mass loss", "color change", "all"],
  answer: "all"
},
{
  question: "Steeper graph means:",
  options: ["faster rate", "slower", "same", "zero"],
  answer: "faster rate"
},
{
  question: "Flat graph means:",
  options: ["reaction complete", "fast", "start", "increase"],
  answer: "reaction complete"
},
{
  question: "Temperature affects rate because:",
  options: ["kinetic energy changes", "mass changes", "volume changes", "none"],
  answer: "kinetic energy changes"
},
{
  question: "Higher energy → collisions:",
  options: ["more effective", "less effective", "same", "none"],
  answer: "more effective"
},
{
  question: "Low temperature causes:",
  options: ["slow reaction", "fast reaction", "same", "none"],
  answer: "slow reaction"
},
{
  question: "Rate law relates:",
  options: ["rate & concentration", "mass & volume", "energy & pressure", "none"],
  answer: "rate & concentration"
},
{
  question: "Order of reaction shows:",
  options: ["dependence on concentration", "mass", "volume", "temperature"],
  answer: "dependence on concentration"
},
{
  question: "Zero order rate is:",
  options: ["constant", "variable", "zero", "random"],
  answer: "constant"
},
{
  question: "First order depends on:",
  options: ["one reactant", "two reactants", "none", "all"],
  answer: "one reactant"
},
{
  question: "Second order depends on:",
  options: ["two factors", "one", "none", "zero"],
  answer: "two factors"
},
{
  question: "Fast reactions have:",
  options: ["low Ea", "high Ea", "no Ea", "none"],
  answer: "low Ea"
},
{
  question: "Slow reactions have:",
  options: ["high Ea", "low Ea", "none", "zero"],
  answer: "high Ea"
},
{
  question: "Catalyst does NOT change:",
  options: ["products", "rate", "Ea", "pathway"],
  answer: "products"
},

{
  question: "Equilibrium occurs when:",
  options: ["forward rate = backward rate", "reaction stops", "products only", "reactants only"],
  answer: "forward rate = backward rate"
},
{
  question: "Dynamic equilibrium means:",
  options: ["reactions continue", "reaction stops", "no change", "solid forms"],
  answer: "reactions continue"
},
{
  question: "At equilibrium concentrations are:",
  options: ["constant", "equal", "zero", "changing"],
  answer: "constant"
},
{
  question: "Le Chatelier principle predicts:",
  options: ["effect of change", "mass", "volume", "color"],
  answer: "effect of change"
},
{
  question: "Increase concentration of reactant shifts:",
  options: ["right", "left", "no change", "random"],
  answer: "right"
},
{
  question: "Decrease reactant shifts:",
  options: ["left", "right", "none", "random"],
  answer: "left"
},
{
  question: "Increase pressure favors:",
  options: ["fewer moles gas", "more moles", "none", "liquid"],
  answer: "fewer moles gas"
},
{
  question: "Decrease pressure favors:",
  options: ["more moles gas", "fewer", "none", "solid"],
  answer: "more moles gas"
},
{
  question: "Temperature increase in exothermic shifts:",
  options: ["left", "right", "none", "random"],
  answer: "left"
},
{
  question: "Temperature increase in endothermic shifts:",
  options: ["right", "left", "none", "random"],
  answer: "right"
},
{
  question: "Catalyst effect on equilibrium:",
  options: ["no shift", "shifts right", "shifts left", "stops reaction"],
  answer: "no shift"
},
{
  question: "Catalyst affects:",
  options: ["rate only", "position", "products", "reactants"],
  answer: "rate only"
},
{
  question: "Kc > 1 means:",
  options: ["products favored", "reactants favored", "equal", "zero"],
  answer: "products favored"
},
{
  question: "Kc < 1 means:",
  options: ["reactants favored", "products", "equal", "zero"],
  answer: "reactants favored"
},
{
  question: "Kc = 1 means:",
  options: ["balanced", "products only", "reactants only", "none"],
  answer: "balanced"
},
{
  question: "Write Kc for A + B ⇌ C:",
  options: ["[C]/[A][B]", "[A][B]/[C]", "[C][A]/[B]", "[A]/[B]"],
  answer: "[C]/[A][B]"
},
{
  question: "Write Kc for 2A ⇌ B:",
  options: ["[B]/[A]²", "[A]²/[B]", "[B]/[A]", "[A]/[B]"],
  answer: "[B]/[A]²"
},
{
  question: "If [A]=2, [B]=3, [C]=6, Kc for A+B⇌C",
  options: ["1", "2", "3", "6"],
  answer: "1"
},
{
  question: "If products increase, equilibrium:",
  options: ["shifts left", "right", "none", "random"],
  answer: "shifts left"
},
{
  question: "Closed system is required for:",
  options: ["equilibrium", "reaction", "heat", "mass"],
  answer: "equilibrium"
},
{
  question: "Equilibrium constant depends on:",
  options: ["temperature", "pressure", "volume", "concentration"],
  answer: "temperature"
},
{
  question: "Changing pressure affects:",
  options: ["gases only", "solids", "liquids", "all"],
  answer: "gases only"
},
{
  question: "Adding inert gas affects:",
  options: ["no change", "shift right", "shift left", "stop"],
  answer: "no change"
},
{
  question: "Exothermic forward has:",
  options: ["negative ΔH", "positive ΔH", "zero", "none"],
  answer: "negative ΔH"
},
{
  question: "Endothermic forward has:",
  options: ["positive ΔH", "negative ΔH", "zero", "none"],
  answer: "positive ΔH"
},
{
  question: "Equilibrium is reached faster with:",
  options: ["catalyst", "heat", "pressure", "volume"],
  answer: "catalyst"
},
{
  question: "Equilibrium is disturbed by:",
  options: ["change in conditions", "constant temp", "constant pressure", "none"],
  answer: "change in conditions"
},
{
  question: "If system shifts right, products:",
  options: ["increase", "decrease", "same", "zero"],
  answer: "increase"
},
{
  question: "If system shifts left, reactants:",
  options: ["increase", "decrease", "same", "zero"],
  answer: "increase"
},
{
  question: "Equilibrium in Haber process:",
  options: ["N2+3H2⇌2NH3", "H2+O2", "CO2 formation", "none"],
  answer: "N2+3H2⇌2NH3"
},
{
  question: "High pressure in Haber favors:",
  options: ["NH3", "N2", "H2", "none"],
  answer: "NH3"
},
{
  question: "High temperature in Haber:",
  options: ["reduces yield", "increases yield", "no change", "none"],
  answer: "reduces yield"
},
{
  question: "Equilibrium yield depends on:",
  options: ["conditions", "mass", "color", "shape"],
  answer: "conditions"
},
{
  question: "Position of equilibrium is:",
  options: ["ratio of products/reactants", "mass", "volume", "color"],
  answer: "ratio of products/reactants"
},
{
  question: "Equilibrium constant remains:",
  options: ["constant at temp", "variable", "zero", "none"],
  answer: "constant at temp"
},
{
  question: "Kc uses:",
  options: ["concentration", "mass", "volume", "pressure"],
  answer: "concentration"
},
{
  question: "Equilibrium is dynamic because:",
  options: ["both reactions continue", "stops", "no change", "solid forms"],
  answer: "both reactions continue"
},
{
  question: "System resists change:",
  options: ["Le Chatelier", "Boyle", "Charles", "Avogadro"],
  answer: "Le Chatelier"
},

{
  question: "Acid is substance that:",
  options: ["donates H+", "accepts H+", "donates OH−", "accepts electrons"],
  answer: "donates H+"
},
{
  question: "Base is substance that:",
  options: ["accepts H+", "donates H+", "donates electrons", "none"],
  answer: "accepts H+"
},
{
  question: "Alkali is:",
  options: ["soluble base", "acid", "salt", "gas"],
  answer: "soluble base"
},
{
  question: "pH scale range:",
  options: ["0–14", "1–10", "0–10", "1–14"],
  answer: "0–14"
},
{
  question: "pH of neutral solution:",
  options: ["7", "0", "14", "1"],
  answer: "7"
},
{
  question: "pH less than 7:",
  options: ["acidic", "basic", "neutral", "alkaline"],
  answer: "acidic"
},
{
  question: "pH greater than 7:",
  options: ["alkaline", "acidic", "neutral", "none"],
  answer: "alkaline"
},
{
  question: "Strong acid example:",
  options: ["HCl", "CH3COOH", "NH3", "NaOH"],
  answer: "HCl"
},
{
  question: "Weak acid example:",
  options: ["CH3COOH", "HCl", "H2SO4", "HNO3"],
  answer: "CH3COOH"
},
{
  question: "Strong base example:",
  options: ["NaOH", "NH3", "HCl", "CO2"],
  answer: "NaOH"
},
{
  question: "Weak base example:",
  options: ["NH3", "NaOH", "KOH", "CaO"],
  answer: "NH3"
},
{
  question: "Indicator changes color:",
  options: ["with pH", "mass", "volume", "pressure"],
  answer: "with pH"
},
{
  question: "Litmus in acid:",
  options: ["red", "blue", "green", "yellow"],
  answer: "red"
},
{
  question: "Litmus in base:",
  options: ["blue", "red", "green", "yellow"],
  answer: "blue"
},
{
  question: "Phenolphthalein in acid:",
  options: ["colorless", "pink", "blue", "green"],
  answer: "colorless"
},
{
  question: "Phenolphthalein in base:",
  options: ["pink", "colorless", "blue", "green"],
  answer: "pink"
},
{
  question: "Neutralization produces:",
  options: ["salt + water", "acid + base", "gas", "heat only"],
  answer: "salt + water"
},
{
  question: "HCl + NaOH →",
  options: ["NaCl + H2O", "H2O only", "NaOH", "HCl"],
  answer: "NaCl + H2O"
},
{
  question: "Salt from strong acid + strong base:",
  options: ["neutral", "acidic", "basic", "none"],
  answer: "neutral"
},
{
  question: "Salt from strong acid + weak base:",
  options: ["acidic", "basic", "neutral", "none"],
  answer: "acidic"
},
{
  question: "Salt from weak acid + strong base:",
  options: ["basic", "acidic", "neutral", "none"],
  answer: "basic"
},
{
  question: "pH of strong acid:",
  options: ["low", "high", "7", "neutral"],
  answer: "low"
},
{
  question: "pH of strong base:",
  options: ["high", "low", "7", "neutral"],
  answer: "high"
},
{
  question: "pH = 2 is:",
  options: ["strong acid", "weak acid", "neutral", "base"],
  answer: "strong acid"
},
{
  question: "pH = 12 is:",
  options: ["strong base", "acid", "neutral", "weak acid"],
  answer: "strong base"
},
{
  question: "If [H+] = 1×10⁻³, pH =",
  options: ["3", "1", "10", "7"],
  answer: "3"
},
{
  question: "If pH = 4, [H+] =",
  options: ["1×10⁻⁴", "1×10⁻³", "1×10⁻²", "1×10⁻¹"],
  answer: "1×10⁻⁴"
},
{
  question: "Titration measures:",
  options: ["concentration", "mass", "volume", "pressure"],
  answer: "concentration"
},
{
  question: "End point is:",
  options: ["color change", "start", "finish", "none"],
  answer: "color change"
},
{
  question: "Equivalence point is:",
  options: ["exact neutralization", "color change", "start", "none"],
  answer: "exact neutralization"
},
{
  question: "If 0.1M acid reacts with 0.1M base:",
  options: ["equal volumes", "unequal", "none", "random"],
  answer: "equal volumes"
},
{
  question: "If C1V1=C2V2, find V2 if equal C:",
  options: ["V1", "2V1", "V1/2", "none"],
  answer: "V1"
},
{
  question: "Dilution reduces:",
  options: ["concentration", "mass", "volume", "pressure"],
  answer: "concentration"
},
{
  question: "Adding water to acid:",
  options: ["dilutes", "concentrates", "neutralizes", "none"],
  answer: "dilutes"
},
{
  question: "Strong acids fully:",
  options: ["ionize", "partially ionize", "do not ionize", "none"],
  answer: "ionize"
},
{
  question: "Weak acids:",
  options: ["partially ionize", "fully ionize", "none", "zero"],
  answer: "partially ionize"
},
{
  question: "Buffer solution resists:",
  options: ["pH change", "mass", "volume", "pressure"],
  answer: "pH change"
},
{
  question: "Acid-base reaction is:",
  options: ["neutralization", "oxidation", "reduction", "none"],
  answer: "neutralization"
},
{
  question: "Salt hydrolysis affects:",
  options: ["pH", "mass", "volume", "pressure"],
  answer: "pH"
},
{
  question: "Universal indicator shows:",
  options: ["pH scale", "mass", "volume", "pressure"],
  answer: "pH scale"
},

{
  question: "Oxidation is:",
  options: ["loss of electrons", "gain of electrons", "gain of oxygen", "loss of hydrogen"],
  answer: "loss of electrons"
},
{
  question: "Reduction is:",
  options: ["gain of electrons", "loss of electrons", "gain of oxygen", "loss of hydrogen"],
  answer: "gain of electrons"
},
{
  question: "Oxidizing agent:",
  options: ["accepts electrons", "donates electrons", "loses electrons", "none"],
  answer: "accepts electrons"
},
{
  question: "Reducing agent:",
  options: ["donates electrons", "accepts electrons", "gains electrons", "none"],
  answer: "donates electrons"
},
{
  question: "Oxidation number of O in compounds:",
  options: ["−2", "−1", "0", "+2"],
  answer: "−2"
},
{
  question: "Oxidation number of H:",
  options: ["+1", "−1", "0", "+2"],
  answer: "+1"
},
{
  question: "Oxidation number of Na:",
  options: ["+1", "−1", "0", "+2"],
  answer: "+1"
},
{
  question: "Oxidation number of Cl in NaCl:",
  options: ["−1", "+1", "0", "+2"],
  answer: "−1"
},
{
  question: "Element in free state has oxidation number:",
  options: ["0", "+1", "−1", "+2"],
  answer: "0"
},
{
  question: "Increase in oxidation number means:",
  options: ["oxidation", "reduction", "neutral", "none"],
  answer: "oxidation"
},
{
  question: "Decrease in oxidation number means:",
  options: ["reduction", "oxidation", "neutral", "none"],
  answer: "reduction"
},
{
  question: "Electrolysis is:",
  options: ["chemical decomposition by electricity", "heating", "cooling", "reaction"],
  answer: "chemical decomposition by electricity"
},
{
  question: "Anode is:",
  options: ["positive electrode", "negative", "neutral", "none"],
  answer: "positive electrode"
},
{
  question: "Cathode is:",
  options: ["negative electrode", "positive", "neutral", "none"],
  answer: "negative electrode"
},
{
  question: "Oxidation occurs at:",
  options: ["anode", "cathode", "electrolyte", "none"],
  answer: "anode"
},
{
  question: "Reduction occurs at:",
  options: ["cathode", "anode", "electrolyte", "none"],
  answer: "cathode"
},
{
  question: "Electrolyte conducts via:",
  options: ["ions", "electrons", "atoms", "protons"],
  answer: "ions"
},
{
  question: "Molten NaCl gives Na at:",
  options: ["cathode", "anode", "solution", "none"],
  answer: "cathode"
},
{
  question: "Molten NaCl gives Cl2 at:",
  options: ["anode", "cathode", "solution", "none"],
  answer: "anode"
},
{
  question: "Faraday constant is:",
  options: ["96500 C/mol", "1000", "6.02×10²³", "22.4"],
  answer: "96500 C/mol"
},
{
  question: "Charge =",
  options: ["current × time", "mass/time", "energy/time", "none"],
  answer: "current × time"
},
{
  question: "Unit of charge:",
  options: ["coulomb", "joule", "watt", "volt"],
  answer: "coulomb"
},
{
  question: "Unit of current:",
  options: ["ampere", "volt", "ohm", "coulomb"],
  answer: "ampere"
},
{
  question: "If current = 2A, time = 5s, charge =",
  options: ["10C", "5C", "2C", "7C"],
  answer: "10C"
},
{
  question: "Faraday law relates mass to:",
  options: ["charge", "time", "volume", "pressure"],
  answer: "charge"
},
{
  question: "Mass deposited ∝",
  options: ["charge", "volume", "mass", "pressure"],
  answer: "charge"
},
{
  question: "Electroplating is:",
  options: ["coating metal", "heating", "cooling", "reaction"],
  answer: "coating metal"
},
{
  question: "In electroplating, object is:",
  options: ["cathode", "anode", "electrolyte", "none"],
  answer: "cathode"
},
{
  question: "Electrochemical cell produces:",
  options: ["electricity", "heat", "light", "mass"],
  answer: "electricity"
},
{
  question: "Voltaic cell is:",
  options: ["spontaneous reaction", "non-spontaneous", "neutral", "none"],
  answer: "spontaneous reaction"
},
{
  question: "Ecell positive means:",
  options: ["spontaneous", "non-spontaneous", "neutral", "none"],
  answer: "spontaneous"
},
{
  question: "Ecell negative means:",
  options: ["non-spontaneous", "spontaneous", "neutral", "none"],
  answer: "non-spontaneous"
},
{
  question: "Anode in voltaic cell is:",
  options: ["negative", "positive", "neutral", "none"],
  answer: "negative"
},
{
  question: "Cathode in voltaic cell is:",
  options: ["positive", "negative", "neutral", "none"],
  answer: "positive"
},
{
  question: "Salt bridge allows:",
  options: ["ion flow", "electron flow", "mass flow", "none"],
  answer: "ion flow"
},
{
  question: "Electrons flow from:",
  options: ["anode to cathode", "cathode to anode", "none", "random"],
  answer: "anode to cathode"
},
{
  question: "Redox reaction involves:",
  options: ["electron transfer", "mass", "volume", "pressure"],
  answer: "electron transfer"
},
{
  question: "Oxidation number of Fe in Fe2O3:",
  options: ["+3", "+2", "−3", "0"],
  answer: "+3"
},
{
  question: "Reduction involves:",
  options: ["gain of electrons", "loss", "mass", "volume"],
  answer: "gain of electrons"
},
{
  question: "Oxidation involves:",
  options: ["loss of electrons", "gain", "mass", "volume"],
  answer: "loss of electrons"
},

{
  question: "Organic chemistry studies:",
  options: ["carbon compounds", "metals", "salts", "gases"],
  answer: "carbon compounds"
},
{
  question: "Hydrocarbons contain:",
  options: ["C and H", "C only", "H only", "C and O"],
  answer: "C and H"
},
{
  question: "Alkanes are:",
  options: ["saturated", "unsaturated", "aromatic", "ionic"],
  answer: "saturated"
},
{
  question: "Alkenes are:",
  options: ["unsaturated", "saturated", "ionic", "metallic"],
  answer: "unsaturated"
},
{
  question: "Alkynes have:",
  options: ["triple bond", "double bond", "single bond", "ionic"],
  answer: "triple bond"
},
{
  question: "General formula of alkenes:",
  options: ["CnH2n", "CnH2n+2", "CnH2n−2", "CnHn"],
  answer: "CnH2n"
},
{
  question: "General formula of alkynes:",
  options: ["CnH2n−2", "CnH2n", "CnH2n+2", "CnHn"],
  answer: "CnH2n−2"
},
{
  question: "First alkane is:",
  options: ["methane", "ethane", "propane", "butane"],
  answer: "methane"
},
{
  question: "CH4 is:",
  options: ["methane", "ethane", "propane", "butane"],
  answer: "methane"
},
{
  question: "C2H6 is:",
  options: ["ethane", "methane", "propane", "butene"],
  answer: "ethane"
},
{
  question: "C2H4 is:",
  options: ["ethene", "ethane", "ethyne", "methane"],
  answer: "ethene"
},
{
  question: "C2H2 is:",
  options: ["ethyne", "ethene", "ethane", "methane"],
  answer: "ethyne"
},
{
  question: "Homologous series have:",
  options: ["same functional group", "same mass", "same formula", "same color"],
  answer: "same functional group"
},
{
  question: "Difference between members:",
  options: ["CH2", "H2", "C2H4", "O2"],
  answer: "CH2"
},
{
  question: "Functional group determines:",
  options: ["properties", "mass", "volume", "color"],
  answer: "properties"
},
{
  question: "Alcohol group:",
  options: ["–OH", "–COOH", "–NH2", "–CHO"],
  answer: "–OH"
},
{
  question: "Carboxylic acid group:",
  options: ["–COOH", "–OH", "–NH2", "–CHO"],
  answer: "–COOH"
},
{
  question: "Alkene functional group:",
  options: ["C=C", "C–C", "C≡C", "C=O"],
  answer: "C=C"
},
{
  question: "Alkyne functional group:",
  options: ["C≡C", "C=C", "C–C", "C=O"],
  answer: "C≡C"
},
{
  question: "Isomerism is:",
  options: ["same formula different structure", "same structure", "same mass", "none"],
  answer: "same formula different structure"
},
{
  question: "Example of isomers:",
  options: ["butane & methylpropane", "CH4 & C2H6", "CO2 & H2O", "NaCl"],
  answer: "butane & methylpropane"
},
{
  question: "Cracking produces:",
  options: ["smaller molecules", "bigger", "same", "none"],
  answer: "smaller molecules"
},
{
  question: "Combustion produces:",
  options: ["CO2 + H2O", "CO only", "H2O only", "C only"],
  answer: "CO2 + H2O"
},
{
  question: "Incomplete combustion produces:",
  options: ["CO", "CO2", "H2O", "O2"],
  answer: "CO"
},
{
  question: "Alkenes react with:",
  options: ["bromine", "oxygen", "water", "salt"],
  answer: "bromine"
},
{
  question: "Bromine water test:",
  options: ["decolorized", "blue", "green", "no change"],
  answer: "decolorized"
},
{
  question: "Addition reaction occurs in:",
  options: ["alkenes", "alkanes", "acids", "bases"],
  answer: "alkenes"
},
{
  question: "Substitution occurs in:",
  options: ["alkanes", "alkenes", "alkynes", "alcohols"],
  answer: "alkanes"
},
{
  question: "Polymerization forms:",
  options: ["large molecules", "small molecules", "ions", "none"],
  answer: "large molecules"
},
{
  question: "Ethene forms polymer:",
  options: ["polyethene", "polypropene", "PVC", "nylon"],
  answer: "polyethene"
},
{
  question: "Alcohol oxidation produces:",
  options: ["acid", "alkane", "alkene", "gas"],
  answer: "acid"
},
{
  question: "Ethanol formula:",
  options: ["C2H5OH", "CH3OH", "C2H6", "C2H4"],
  answer: "C2H5OH"
},
{
  question: "Carboxylic acids are:",
  options: ["weak acids", "strong acids", "bases", "neutral"],
  answer: "weak acids"
},
{
  question: "Esters smell:",
  options: ["fruity", "rotten", "neutral", "acidic"],
  answer: "fruity"
},
{
  question: "Ester formed from:",
  options: ["acid + alcohol", "acid + base", "base + salt", "none"],
  answer: "acid + alcohol"
},
{
  question: "Soap is made by:",
  options: ["saponification", "cracking", "combustion", "none"],
  answer: "saponification"
},
{
  question: "Hydrocarbon burning releases:",
  options: ["energy", "mass", "volume", "pressure"],
  answer: "energy"
},
{
  question: "Organic compounds mostly:",
  options: ["covalent", "ionic", "metallic", "none"],
  answer: "covalent"
},
{
  question: "Organic compounds generally have:",
  options: ["low melting point", "high melting", "metallic", "ionic"],
  answer: "low melting point"
},
{
  question: "Organic compounds conduct:",
  options: ["poorly", "well", "very well", "none"],
  answer: "poorly"
},

{
  question: "A gas occupies 11.2dm³ at STP. Number of moles is:",
  options: ["0.5", "1", "2", "4"],
  answer: "0.5"
},
{
  question: "0.5 mol of CO2 has mass:",
  options: ["22g", "44g", "11g", "88g"],
  answer: "22g"
},
{
  question: "Which has highest boiling point?",
  options: ["H2O", "CO2", "CH4", "O2"],
  answer: "H2O"
},
{
  question: "Which compound conducts electricity in solution?",
  options: ["NaCl", "CH4", "C2H6", "CO2"],
  answer: "NaCl"
},
{
  question: "Which process is endothermic?",
  options: ["photosynthesis", "combustion", "neutralization", "respiration"],
  answer: "photosynthesis"
},
{
  question: "Which reaction rate is fastest?",
  options: ["powder + acid", "lump + acid", "cold reaction", "low pressure"],
  answer: "powder + acid"
},
{
  question: "Which gas diffuses fastest?",
  options: ["H2", "CO2", "O2", "N2"],
  answer: "H2"
},
{
  question: "Which shifts equilibrium right?",
  options: ["increase reactant", "remove product", "both", "none"],
  answer: "both"
},
{
  question: "Which is strongest acid?",
  options: ["HCl", "CH3COOH", "NH3", "H2O"],
  answer: "HCl"
},
{
  question: "pH of strong base is:",
  options: [">7", "<7", "7", "0"],
  answer: ">7"
},
{
  question: "Oxidation involves:",
  options: ["loss of electrons", "gain", "mass", "volume"],
  answer: "loss of electrons"
},
{
  question: "In electrolysis, cathode is:",
  options: ["negative", "positive", "neutral", "none"],
  answer: "negative"
},
{
  question: "Organic compound with –OH is:",
  options: ["alcohol", "acid", "alkane", "alkene"],
  answer: "alcohol"
},
{
  question: "Polymer is:",
  options: ["large molecule", "small molecule", "ion", "gas"],
  answer: "large molecule"
},
{
  question: "Isomerism means:",
  options: ["same formula diff structure", "same structure", "same mass", "none"],
  answer: "same formula diff structure"
},
{
  question: "Atomic number equals:",
  options: ["protons", "neutrons", "mass", "electrons only"],
  answer: "protons"
},
{
  question: "Ionic bond involves:",
  options: ["electron transfer", "sharing", "none", "protons"],
  answer: "electron transfer"
},
{
  question: "Covalent bond involves:",
  options: ["sharing electrons", "transfer", "none", "mass"],
  answer: "sharing electrons"
},
{
  question: "Which has strongest intermolecular force?",
  options: ["H2O", "CO2", "CH4", "O2"],
  answer: "H2O"
},
{
  question: "Which gas law relates P and V?",
  options: ["Boyle", "Charles", "Avogadro", "Graham"],
  answer: "Boyle"
},
{
  question: "If temperature increases, kinetic energy:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "Catalyst increases rate by:",
  options: ["lowering Ea", "raising Ea", "none", "changing products"],
  answer: "lowering Ea"
},
{
  question: "Equilibrium constant depends on:",
  options: ["temperature", "pressure", "volume", "concentration"],
  answer: "temperature"
},
{
  question: "Neutralization produces:",
  options: ["salt + water", "gas", "acid", "base"],
  answer: "salt + water"
},
{
  question: "Which is reducing agent?",
  options: ["electron donor", "acceptor", "none", "gas"],
  answer: "electron donor"
},
{
  question: "Which is oxidizing agent?",
  options: ["electron acceptor", "donor", "none", "gas"],
  answer: "electron acceptor"
},
{
  question: "Electrochemical cell produces:",
  options: ["electricity", "heat", "gas", "mass"],
  answer: "electricity"
},
{
  question: "Ecell positive means:",
  options: ["spontaneous", "non", "neutral", "none"],
  answer: "spontaneous"
},
{
  question: "Cracking produces:",
  options: ["smaller molecules", "larger", "same", "none"],
  answer: "smaller molecules"
},
{
  question: "Addition occurs in:",
  options: ["alkenes", "alkanes", "none", "acids"],
  answer: "alkenes"
},


{
  question: "A student reacts 2g of Mg with excess HCl. Which gas is produced?",
  options: ["H2", "O2", "CO2", "Cl2"],
  answer: "H2"
},
{
  question: "If gas volume doubles at constant temp, pressure:",
  options: ["halves", "doubles", "same", "zero"],
  answer: "halves"
},
{
  question: "A reaction gives ΔH = −50kJ. This means:",
  options: ["exothermic", "endothermic", "neutral", "none"],
  answer: "exothermic"
},
{
  question: "Which condition increases ammonia yield in Haber?",
  options: ["high pressure", "low pressure", "low temp only", "none"],
  answer: "high pressure"
},
{
  question: "A solution with pH 3 is:",
  options: ["acidic", "basic", "neutral", "alkaline"],
  answer: "acidic"
},
{
  question: "Electrolysis of CuSO4 produces Cu at:",
  options: ["cathode", "anode", "solution", "none"],
  answer: "cathode"
},
{
  question: "If activation energy is high, reaction is:",
  options: ["slow", "fast", "instant", "none"],
  answer: "slow"
},
{
  question: "A hydrocarbon burns completely to give:",
  options: ["CO2 and H2O", "CO only", "C only", "H2 only"],
  answer: "CO2 and H2O"
},
{
  question: "Which compound shows hydrogen bonding?",
  options: ["H2O", "CH4", "CO2", "O2"],
  answer: "H2O"
},
{
  question: "If reactant concentration decreases, rate:",
  options: ["decreases", "increases", "same", "zero"],
  answer: "decreases"
},

{
  question: "Group 1 elements are:",
  options: ["alkali metals", "halogens", "noble gases", "transition"],
  answer: "alkali metals"
},
{
  question: "Group 7 elements are:",
  options: ["halogens", "alkali", "noble", "transition"],
  answer: "halogens"
},
{
  question: "Reactivity of Group 1:",
  options: ["increases down", "decreases", "constant", "none"],
  answer: "increases down"
},
{
  question: "Reactivity of halogens:",
  options: ["decreases down", "increases", "constant", "none"],
  answer: "decreases down"
},
{
  question: "Atomic radius trend:",
  options: ["increases down", "decreases down", "constant", "random"],
  answer: "increases down"
},
{
  question: "Ionization energy trend:",
  options: ["decreases down", "increases down", "constant", "none"],
  answer: "decreases down"
},
{
  question: "Transition metals show:",
  options: ["variable oxidation states", "fixed", "none", "zero"],
  answer: "variable oxidation states"
},
{
  question: "Transition metals are good:",
  options: ["catalysts", "acids", "bases", "gases"],
  answer: "catalysts"
},
{
  question: "Flame test for Na:",
  options: ["yellow", "blue", "green", "red"],
  answer: "yellow"
},
{
  question: "Flame test for K:",
  options: ["lilac", "yellow", "green", "red"],
  answer: "lilac"
},
{
  question: "CO2 test:",
  options: ["limewater milky", "blue", "green", "none"],
  answer: "limewater milky"
},
{
  question: "NH3 test:",
  options: ["turns red litmus blue", "blue to red", "none", "colorless"],
  answer: "turns red litmus blue"
},
{
  question: "Cl2 test:",
  options: ["bleaches litmus", "turns red", "green", "none"],
  answer: "bleaches litmus"
},
{
  question: "SO2 test:",
  options: ["decolorizes KMnO4", "blue", "green", "none"],
  answer: "decolorizes KMnO4"
},
{
  question: "Gas that pops with flame:",
  options: ["H2", "O2", "CO2", "N2"],
  answer: "H2"
},
{
  question: "Gas relights glowing splint:",
  options: ["O2", "CO2", "H2", "N2"],
  answer: "O2"
},
{
  question: "CO2 extinguishes flame because:",
  options: ["no oxygen", "heavy", "cold", "none"],
  answer: "no oxygen"
},
{
  question: "Contact process produces:",
  options: ["H2SO4", "NH3", "CO2", "HCl"],
  answer: "H2SO4"
},
{
  question: "Haber process produces:",
  options: ["NH3", "H2SO4", "CO2", "HCl"],
  answer: "NH3"
},
{
  question: "Conditions for Haber:",
  options: ["high pressure", "low pressure", "room temp", "none"],
  answer: "high pressure"
},
{
  question: "Catalyst in Haber:",
  options: ["iron", "copper", "nickel", "zinc"],
  answer: "iron"
},
{
  question: "Contact process catalyst:",
  options: ["V2O5", "Fe", "Cu", "Zn"],
  answer: "V2O5"
},
{
  question: "Petroleum is:",
  options: ["mixture of hydrocarbons", "compound", "element", "none"],
  answer: "mixture of hydrocarbons"
},
{
  question: "Fractional distillation separates by:",
  options: ["boiling point", "mass", "volume", "color"],
  answer: "boiling point"
},
{
  question: "Gas fraction used for:",
  options: ["fuel", "plastic", "medicine", "none"],
  answer: "fuel"
},
{
  question: "Crude oil refining produces:",
  options: ["fractions", "elements", "salts", "none"],
  answer: "fractions"
},
{
  question: "Air pollution causes:",
  options: ["acid rain", "growth", "energy", "none"],
  answer: "acid rain"
},
{
  question: "SO2 causes:",
  options: ["acid rain", "warming", "cooling", "none"],
  answer: "acid rain"
},
{
  question: "CO is dangerous because:",
  options: ["binds haemoglobin", "burns", "reacts", "none"],
  answer: "binds haemoglobin"
},
{
  question: "Water treatment includes:",
  options: ["filtration", "reaction", "burning", "none"],
  answer: "filtration"
},
{
  question: "Hard water contains:",
  options: ["Ca2+, Mg2+", "Na+", "K+", "H+"],
  answer: "Ca2+, Mg2+"
},
{
  question: "Temporary hardness removed by:",
  options: ["boiling", "filtering", "cooling", "none"],
  answer: "boiling"
},
{
  question: "Permanent hardness removed by:",
  options: ["ion exchange", "boiling", "none", "cooling"],
  answer: "ion exchange"
},
{
  question: "Biodegradable substances:",
  options: ["break down", "do not", "react", "none"],
  answer: "break down"
},
{
  question: "Greenhouse gas:",
  options: ["CO2", "O2", "N2", "H2"],
  answer: "CO2"
},
{
  question: "Ozone protects from:",
  options: ["UV rays", "heat", "rain", "wind"],
  answer: "UV rays"
},
{
  question: "Electrolysis mass depends on:",
  options: ["charge", "volume", "mass", "pressure"],
  answer: "charge"
},
{
  question: "If current doubles, mass deposited:",
  options: ["doubles", "halves", "same", "zero"],
  answer: "doubles"
},
{
  question: "Time increase → mass:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "Electrolysis of CuSO4 uses electrode:",
  options: ["copper", "iron", "zinc", "none"],
  answer: "copper"
},

{
  question: "The diagram shows a filtration setup. What is the residue?",
  image: "/images/chem1.png",
  options: ["Liquid that passes through", "Solid left on filter paper", "Gas produced", "Evaporated substance"],
  answer: "Solid left on filter paper"
},

{
  question: "The diagram shows a distillation setup. What is the function of the condenser?",
  image: "/images/chem2.png",
  options: ["To heat liquid", "To cool vapor", "To measure volume", "To filter solid"],
  answer: "To cool vapor"
},

{
  question: "The diagram shows a burette and pipette setup. What is this used for?",
  image: "/images/chem3.png",
  options: ["Filtration", "Titration", "Distillation", "Evaporation"],
  answer: "Titration"
},

{
  question: "The diagram shows a Bunsen burner flame. Which part is the hottest?",
  image: "/images/chem4.png",
  options: ["Outer blue flame", "Inner yellow flame", "Base", "Top"],
  answer: "Outer blue flame"
},

{
  question: "The diagram shows measuring cylinder readings. What is the correct reading method?",
  image: "/images/chem5.png",
  options: ["Top of liquid", "Bottom of meniscus", "Side view", "Any point"],
  answer: "Bottom of meniscus"
},

{
  question: "The diagram shows hazard symbols. What does the symbol indicate?",
  image: "/images/chem6.png",
  options: ["Flammable", "Corrosive", "Toxic", "Explosive"],
  answer: "Corrosive"
},

{
  question: "The diagram shows separation of immiscible liquids. What apparatus is used?",
  image: "/images/chem7.png",
  options: ["Separating funnel", "Burette", "Beaker", "Test tube"],
  answer: "Separating funnel"
},

{
  question: "The diagram shows evaporation process. What remains after evaporation?",
  image: "/images/chem8.png",
  options: ["Solvent", "Solute", "Gas", "Nothing"],
  answer: "Solute"
},

{
  question: "The diagram shows heating of a substance in a test tube. Why is the tube held at an angle?",
  image: "/images/chem9.png",
  options: ["To prevent spillage", "To allow gas escape safely", "To cool faster", "To increase heat"],
  answer: "To allow gas escape safely"
},

{
  question: "The diagram shows a thermometer in liquid. What is being measured?",
  image: "/images/chem10.png",
  options: ["Mass", "Temperature", "Volume", "Pressure"],
  answer: "Temperature"
},

{
  question: "The diagram shows Rutherfordâ€™s alpha scattering experiment. What was the major conclusion?",
  image: "/images/chem11.png",
  options: ["Atom is solid", "Atom has a dense nucleus", "Electrons are positive", "Atom is empty"],
  answer: "Atom has a dense nucleus"
},

{
  question: "The diagram shows energy levels of an atom. What do the levels represent?",
  image: "/images/chem12.png",
  options: ["Protons", "Electrons", "Neutrons", "Nucleus"],
  answer: "Electrons"
},

{
  question: "The diagram shows electron arrangement of an element. How many valence electrons are present?",
  image: "/images/chem13.png",
  options: ["2", "6", "8", "4"],
  answer: "6"
},

{
  question: "The diagram shows isotopes of an element. What is common between them?",
  image: "/images/chem14.png",
  options: ["Mass number", "Proton number", "Neutron number", "Atomic mass"],
  answer: "Proton number"
},

{
  question: "The diagram shows a mass spectrum. The peaks represent:",
  image: "/images/chem15.png",
  options: ["Isotopes", "Electrons", "Protons", "Compounds"],
  answer: "Isotopes"
},

{
  question: "The diagram shows periodic table trend across a period. What happens to atomic size?",
  image: "/images/chem16.png",
  options: ["Increases", "Decreases", "Remains constant", "Varies randomly"],
  answer: "Decreases"
},

{
  question: "The diagram shows successive ionization energies. A sharp increase indicates:",
  image: "/images/chem17.png",
  options: ["Outer shell electrons removed", "Inner shell reached", "No electrons left", "Protons removed"],
  answer: "Inner shell reached"
},

{
  question: "The diagram shows orbital shapes. Which orbital is spherical?",
  image: "/images/chem18.png",
  options: ["s-orbital", "p-orbital", "d-orbital", "f-orbital"],
  answer: "s-orbital"
},

{
  question: "The diagram shows electron configuration of an element. Which rule is followed when filling orbitals?",
  image: "/images/chem19.png",
  options: ["Aufbau principle", "Ohmâ€™s law", "Le Chatelierâ€™s principle", "Newtonâ€™s law"],
  answer: "Aufbau principle"
},

{
  question: "The diagram shows elements in the same group. Why do they have similar properties?",
  image: "/images/chem20.png",
  options: ["Same number of shells", "Same valence electrons", "Same mass", "Same neutrons"],
  answer: "Same valence electrons"
},

{
  question: "The diagram shows electron transfer between two atoms. What type of bonding is formed?",
  image: "/images/chem21.png",
  options: ["Ionic bonding", "Covalent bonding", "Metallic bonding", "Hydrogen bonding"],
  answer: "Ionic bonding"
},

{
  question: "The diagram shows shared electrons between atoms. What type of bonding is this?",
  image: "/images/chem22.png",
  options: ["Covalent bonding", "Ionic bonding", "Metallic bonding", "Electrostatic bonding"],
  answer: "Covalent bonding"
},

{
  question: "The diagram shows a dot-and-cross diagram of NaCl. What happens to sodium?",
  image: "/images/chem23.png",
  options: ["Loses one electron", "Gains one electron", "Shares electrons", "Remains unchanged"],
  answer: "Loses one electron"
},

{
  question: "The diagram shows a molecule of oxygen (Oâ‚‚). How many bonds are present?",
  image: "/images/chem24.png",
  options: ["2", "1", "3", "4"],
  answer: "2"
},

{
  question: "The diagram shows a methane molecule (CHâ‚„). What is its shape?",
  image: "/images/chem25.png",
  options: ["Tetrahedral", "Linear", "Trigonal planar", "Bent"],
  answer: "Tetrahedral"
},

{
  question: "The diagram shows ammonia (NHâ‚ƒ). What is its shape?",
  image: "/images/chem26.png",
  options: ["Trigonal pyramidal", "Linear", "Tetrahedral", "Bent"],
  answer: "Trigonal pyramidal"
},

{
  question: "The diagram shows water molecule (Hâ‚‚O). Why is it bent?",
  image: "/images/chem27.png",
  options: ["Lone pairs repel", "Equal bonding", "No electrons", "Strong bonds"],
  answer: "Lone pairs repel"
},

{
  question: "The diagram shows metallic bonding. What holds the atoms together?",
  image: "/images/chem28.png",
  options: ["Delocalized electrons", "Protons", "Neutrons", "Covalent bonds"],
  answer: "Delocalized electrons"
},

{
  question: "The diagram shows a giant ionic lattice. What is a key property?",
  image: "/images/chem29.png",
  options: ["High melting point", "Low melting point", "Soft", "Non-conductive"],
  answer: "High melting point"
},

{
  question: "The diagram shows a simple molecular structure. What is a typical property?",
  image: "/images/chem30.png",
  options: ["Low boiling point", "High melting point", "Hard", "Conductive"],
  answer: "Low boiling point"
},

{
  question: "The diagram shows a graph of pressure against volume for a gas. What law does it represent?",
  image: "/images/chem31.png",
  options: ["Boyleâ€™s law", "Charlesâ€™ law", "Avogadroâ€™s law", "Daltonâ€™s law"],
  answer: "Boyleâ€™s law"
},

{
  question: "The diagram shows volume against temperature. What happens to volume as temperature increases?",
  image: "/images/chem32.png",
  options: ["Increases", "Decreases", "Remains constant", "Becomes zero"],
  answer: "Increases"
},

{
  question: "A gas occupies 2 mÂ³ at a certain pressure. If pressure is doubled (constant temperature), find new volume.",
  image: "/images/chem33.png",
  options: ["1 mÂ³", "2 mÂ³", "4 mÂ³", "0.5 mÂ³"],
  answer: "1 mÂ³"
},

{
  question: "The diagram shows particles in a gas. What is the nature of their motion?",
  image: "/images/chem34.png",
  options: ["Random", "Fixed", "Slow", "Circular"],
  answer: "Random"
},

{
  question: "The diagram shows diffusion of a gas. What causes diffusion?",
  image: "/images/chem35.png",
  options: ["Random motion of particles", "Gravity", "Pressure", "Temperature only"],
  answer: "Random motion of particles"
},

{
  question: "The diagram shows solid, liquid and gas states. Which has the highest kinetic energy?",
  image: "/images/chem36.png",
  options: ["Gas", "Liquid", "Solid", "All equal"],
  answer: "Gas"
},

{
  question: "The diagram shows heating curve of a substance. What happens at the flat region?",
  image: "/images/chem37.png",
  options: ["Change of state", "Temperature increase", "Cooling", "Reaction"],
  answer: "Change of state"
},

{
  question: "The diagram shows evaporation process. What factor increases rate of evaporation?",
  image: "/images/chem38.png",
  options: ["Increase in temperature", "Decrease in temperature", "Increase in pressure", "Cooling"],
  answer: "Increase in temperature"
},

{
  question: "The diagram shows gas particles in a container. If temperature increases, what happens to pressure?",
  image: "/images/chem39.png",
  options: ["Increases", "Decreases", "Remains constant", "Becomes zero"],
  answer: "Increases"
},

{
  question: "The diagram shows two gases diffusing. Which gas diffuses faster?",
  image: "/images/chem40.png",
  options: ["Lighter gas", "Heavier gas", "Equal", "Depends on volume"],
  answer: "Lighter gas"
},

{
  question: "The diagram shows the structure of methane. What type of bonding is present?",
  image: "/images/chem41.png",
  options: ["Covalent bonding", "Ionic bonding", "Metallic bonding", "Hydrogen bonding"],
  answer: "Covalent bonding"
},

{
  question: "The diagram shows an alkene structure. What is the functional group present?",
  image: "/images/chem42.png",
  options: ["C=C", "Câ€“C", "OH", "COOH"],
  answer: "C=C"
},

{
  question: "The diagram shows ethanol molecule. Which functional group is present?",
  image: "/images/chem43.png",
  options: ["OH", "COOH", "NHâ‚‚", "C=C"],
  answer: "OH"
},

{
  question: "The diagram shows ethanoic acid. What is the functional group?",
  image: "/images/chem44.png",
  options: ["COOH", "OH", "NHâ‚‚", "C=C"],
  answer: "COOH"
},

{
  question: "The diagram shows a hydrocarbon undergoing combustion. What are the products?",
  image: "/images/chem45.png",
  options: ["COâ‚‚ and Hâ‚‚O", "CO and Hâ‚‚", "C and Oâ‚‚", "Hâ‚‚ and Oâ‚‚"],
  answer: "COâ‚‚ and Hâ‚‚O"
},

{
  question: "The diagram shows titration setup. What is the end point indicated by?",
  image: "/images/chem46.png",
  options: ["Colour change", "Temperature change", "Gas formation", "Pressure change"],
  answer: "Colour change"
},

{
  question: "The diagram shows pH scale. Which value is strongly acidic?",
  image: "/images/chem47.png",
  options: ["1", "7", "10", "14"],
  answer: "1"
},

{
  question: "The diagram shows neutralization reaction. What is formed?",
  image: "/images/chem48.png",
  options: ["Salt and water", "Acid only", "Base only", "Gas only"],
  answer: "Salt and water"
},

{
  question: "The diagram shows a salt solution being tested. Which indicator is used?",
  image: "/images/chem49.png",
  options: ["Litmus", "Thermometer", "Voltmeter", "Balance"],
  answer: "Litmus"
},

{
  question: "The diagram shows organic molecules with same molecular formula but different structures. What are they called?",
  image: "/images/chem50.png",
  options: ["Isomers", "Elements", "Compounds", "Mixtures"],
  answer: "Isomers"
}


];

export default chemistryQuestions;